"use client";
import { createContext, type PropsWithChildren } from "react";

type ProductViewer = {
  readonly viewerId: string | null;
  readonly signedIn: boolean;
  readonly isSoftmaxTeamMember: boolean;
};

export const ProductViewerContext = createContext<ProductViewer>({
  viewerId: null,
  signedIn: false,
  isSoftmaxTeamMember: false,
});

export function ProductViewerProvider({
  children,
  viewerId,
  signedIn = viewerId !== null,
  isSoftmaxTeamMember,
}: PropsWithChildren<
  Omit<ProductViewer, "signedIn"> & { readonly signedIn?: boolean }
>) {
  return (
    <ProductViewerContext value={{ viewerId, signedIn, isSoftmaxTeamMember }}>
      {children}
    </ProductViewerContext>
  );
}
